/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Patch remediation bridge: mark finding REMEDIATION_PENDING (REQ-RB-*)
 * @export
 * @interface FindingRemediationPendingRequest
 */
export interface FindingRemediationPendingRequest {
    /**
     * Optional patch_instances.id for traceability
     * @type {string}
     * @memberof FindingRemediationPendingRequest
     */
    patchInstanceId?: string;
}

/**
 * Check if a given object implements the FindingRemediationPendingRequest interface.
 */
export function instanceOfFindingRemediationPendingRequest(value: object): value is FindingRemediationPendingRequest {
    return true;
}

export function FindingRemediationPendingRequestFromJSON(json: any): FindingRemediationPendingRequest {
    return FindingRemediationPendingRequestFromJSONTyped(json, false);
}

export function FindingRemediationPendingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindingRemediationPendingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'patchInstanceId': json['patchInstanceId'] == null ? undefined : json['patchInstanceId'],
    };
}

export function FindingRemediationPendingRequestToJSON(json: any): FindingRemediationPendingRequest {
    return FindingRemediationPendingRequestToJSONTyped(json, false);
}

export function FindingRemediationPendingRequestToJSONTyped(value?: FindingRemediationPendingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patchInstanceId': value['patchInstanceId'],
    };
}

